import _JSXStyle from "styled-jsx/style";
import { IconChevronDown24, IconChevronUp24 } from '@dhis2/ui-icons';
import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { TableDataCell } from '../table-elements/index.js';
const pointer = {
  styles: /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "927553068"
  }, ["td.jsx-927553068{cursor:pointer;}"]),
  className: "jsx-927553068"
};
export const ExpandHandleCell = _ref => {
  let {
    expanded,
    onClick
  } = _ref;
  return /*#__PURE__*/React.createElement(TableDataCell, {
    className: cx(pointer.className, {
      expanded
    }),
    onClick: () => onClick({
      expanded: !expanded
    }),
    width: "48px"
  }, expanded ? /*#__PURE__*/React.createElement(IconChevronUp24, null) : /*#__PURE__*/React.createElement(IconChevronDown24, null), pointer.styles);
};
ExpandHandleCell.propTypes = {
  expanded: PropTypes.bool,
  onClick: PropTypes.func
};